import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

export const useFeatureFlags = (): LDFlagSet => {
	const ldFlags = useFlags();
	return useMemo(() => {
		const overridesFlags = ldFlags.enablePercentageRolloutCampaign?.toggles || {}; // Can be null
		return {
			...ldFlags,
			...overridesFlags,
		};
	}, [ldFlags]);
};
